import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";

/**
 * `TooltipTrigger asChild` uses Radix's `Slot`, which requires exactly one
 * child element — hence `children` and the icon are merged into a single
 * wrapping `<span>` here rather than kept as siblings.
 */
export const ErrorTooltip = ({
  message,
  children,
}: {
  message: string;
  children?: React.ReactNode;
}) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex cursor-help items-center gap-0.5">
          {children}
          <AlertTriangle className="h-3 w-3 text-red-500" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs text-xs">{message}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
